module.exports = __webpack_public_path__ + "static/connect-3e4d8eb702ae9d51620e08bdfc8ba0f0.png";